import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";
import { services } from "../../../mocks/homeData";

export default function Services() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="services" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div ref={ref}>
          <div className="text-center mb-12 md:mb-16">
            <div
              className={`inline-block w-12 h-1 rounded-full bg-copper mb-4 ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
            />
            <h2
              className={`font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4 ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
              style={{ animationDelay: "0.1s" }}
            >
              İhtiyacınıza Özel Mühendislik Çözümleri
            </h2>
            <p
              className={`font-body text-base md:text-lg text-gray-600 max-w-2xl mx-auto ${
                isVisible ? "animate-fade-up" : "opacity-0"
              }`}
              style={{ animationDelay: "0.2s" }}
            >
              15 yılı aşkın tecrübemizle her ölçekte endüstriyel yapı projelerinizi hayata geçiriyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`group bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-copper/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl ${
                  isVisible ? "animate-fade-up" : "opacity-0"
                } ${index >= 3 ? "lg:col-span-1 sm:col-span-1" : ""}`}
                style={{
                  animationDelay: `${0.1 + index * 0.1}s`,
                }}
              >
                <div className="relative h-52 md:h-56 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="font-heading font-bold text-lg md:text-xl text-navy mb-2 md:mb-3">
                    {service.title}
                  </h3>
                  <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <Link
                    to={`/hizmetler/${service.slug}`}
                    className="inline-flex items-center gap-2 font-body text-sm font-medium text-copper hover:text-copper-dark transition-colors group/link"
                  >
                    Detaylı İncele
                    <div className="w-4 h-4 flex items-center justify-center group-hover/link:translate-x-1 transition-transform">
                      <i className="ri-arrow-right-line" />
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
